import { useItineraryStore } from '../itinerary'
import Product from '../../models/product'
import { CustomerReview, CustomItinerary, ItineraryRequest } from '../../types'

interface SectionVisibility {
  itinerary: boolean | null
  accommodation: boolean | null
  included: boolean | null
  excluded: boolean | null
  faq: boolean | null
  addon: boolean | null
  'customer-reviews': boolean | null
}

interface ItineraryAnimation {
  actionType: string | null
  accommodation: Record<string, 'pending' | 'animating'>
  activity: Record<string, 'pending' | 'animating'>
}

interface LandingMessages {
  title: string
  activities: any[]
  customize_messages: string[]
  preview_messages: string[]
  matched_country: string
}

interface ItineraryStoreState {
  id: string | null
  data: Product | CustomItinerary | null
  itineraryRequest: ItineraryRequest | null
  itineraryRequestId: string | null
  chatroomId: string | null
  pricePanelIsVisible: boolean
  sectionVisibility: SectionVisibility
  chatEnabled: boolean
  selectedTimeline: {
    days: number[]
    slots: string[]
    ids: number[]
  }
  animation: ItineraryAnimation
  selectedAccommodations: {
    ids: number[]
  }
  onboarding: 'started' | 'finished' | false
  landingMessages: LandingMessages | null
  reviews: CustomerReview[]
  loading: {
    data: boolean
    reviews: boolean
  }
  isReviewModalOpen: boolean
  customerReviewSummary: string[]
}

type ItineraryStore = ReturnType<typeof useItineraryStore>

// Extract only getters and actions (exclude state properties)
type ItineraryGettersAndActions = Omit<
  ItineraryStore,
  | keyof ItineraryStoreState
  | '$id'
  | '$state'
  | '$patch'
  | '$reset'
  | '$subscribe'
  | '$onAction'
  | '$dispose'
  | '$deepPatch'
>

export function useTypedItineraryStore<T extends Product | CustomItinerary>() {
  const store = useItineraryStore()
  return store as ItineraryStoreState & ItineraryGettersAndActions & { data: T | null }
}
